import { Button, TextInput } from 'components/Form'
import { HiOutlineUser } from 'react-icons/hi'
import { Link, useNavigate } from 'react-router-dom'
import { Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import useAuth from 'utils/hooks/useAuth'
import { Success } from 'utils/alerts'
import useQuery from 'utils/hooks/useQuery'

const validationSchema = Yup.object().shape({
    email: Yup.string().required('Email is required'),
    password: Yup.string().required('Password is required'),
})

export default function Login() {
    const navigate = useNavigate()
    const { signIn } = useAuth()
    const query = useQuery()

    const onSignIn = async (values, setSubmitting) => {
        const { email, password } = values
        setSubmitting(true)
        const result = await signIn({ email, password })
        const redirectUrl = query.get('redirectUrl')
        if (result.status !== 'failed') {
            Success('Login successfully!')
            navigate(redirectUrl ? redirectUrl : '/')
        }
        setSubmitting(false)
    }

    return (
        <div className="w-[400px] px-6 py-4">
            <span className="flex justify-center">
                <img src="/images/logo.png" className="w-[70%]" alt="error" />
            </span>
            <div className="text-center mb-4">
                <h4 className="text-black font-bold text-2xl">Welcome!</h4>
                <p className="font-medium">
                    Please enter your credentials to sign in!
                </p>
            </div>
            <Formik
                initialValues={{
                    email: '',
                    password: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting }) => {
                    onSignIn(values, setSubmitting)
                }}
            >
                {({ touched, errors, isSubmitting }) => (
                    <Form className="flex flex-col gap-6">
                        <Field name="email">
                            {({ field, form }) => (
                                <TextInput
                                    type="text"
                                    id="email"
                                    name="email"
                                    className="font-medium"
                                    label="Email"
                                    placeholder={'Enter your email here'}
                                    autoComplete="email"
                                    isFocused={true}
                                    icon={<HiOutlineUser />}
                                    error={errors.email && touched.email}
                                    message={errors.email}
                                    onChange={(e) =>
                                        form.setFieldValue(
                                            field.name,
                                            e.target.value,
                                        )
                                    }
                                />
                            )}
                        </Field>
                        <Field name="password">
                            {({ field, form }) => (
                                <TextInput
                                    id="password"
                                    name="password"
                                    className="font-medium"
                                    label="Password"
                                    placeholder={'Enter your password here'}
                                    autoComplete="password"
                                    password={true}
                                    error={errors.password && touched.password}
                                    message={errors.password}
                                    onChange={(e) =>
                                        form.setFieldValue(
                                            field.name,
                                            e.target.value,
                                        )
                                    }
                                />
                            )}
                        </Field>
                        <Button
                            className="w-full mt-3 text-white font-semibold border-primary bg-primary dark:border-secondary dark:bg-secondary"
                            disabled={isSubmitting}
                            type="submit"
                        >
                            Login
                        </Button>
                    </Form>
                )}
            </Formik>
            <div className="text-center mt-6">
                <p className="font-medium text-[#0077ff]">
                    <Link to="/forgot-password">Forgot your password?</Link>
                </p>
            </div>
            <div className="text-center my-3">
                <p className="font-medium">
                    Don't have an account?
                    <Link to="/forgot-password" className="text-[#0077ff]">
                        {' '}
                        Sign up
                    </Link>
                </p>
            </div>
        </div>
    )
}
